export default [
    {
        path: 'relatorio-financeiro-exame',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-financeiro-exame' */
            '@/views/exame-laboratorial/relatorio-financeiro-exame/Index'
        ),
        redirect: 'relatorio-financeiro-exame/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-financeiro-exame-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-financeiro-exame' */
                    '@/views/exame-laboratorial/relatorio-financeiro-exame/List.vue'
                ),
            },
        ],
    }
]